// Import global utils
import { isDefined } from '@automator/shared/utils/is-defined';

/**
 * Checks whether an action should have the "Filter" button
 * 
 * @param {Integer} actionID The action ID
 * @returns {Boolean} TRUE if we should add the filter button
 */
const canActionHaveFilterButton = ( actionID ) => {
	// Get the action
	const action = UncannyAutomator.recipe.items[ actionID ];

	// Check if the action exists
	if ( ! isDefined( action ) ) {
		return false;
	}

	// Check if it's an action
	if ( action.itemType !== 'action' ) {
		return false;
	}

	// Check if it doesn't have conditions already
	if ( action.hasConditions ) {
		return false;
	}

	// Check if the action is missing
	if ( action.isMissing ) {
		return false;
	}

	return true;
}

export default canActionHaveFilterButton;
